export class SourceType {
    id: number;
    name: string;
}
